const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

const firstText = (...values) => values.map(cleanText).find(Boolean) || '';

const normalizeToken = (value) => cleanText(value)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]/g, '');

const getCustomerName = (order = {}) => firstText(
  order.customer?.name,
  order.customer?.fullName,
  order.customerName,
  order.clientName,
  order.fullOrderData?.customer?.name
);

export const getLocalOrderResponsibility = (order = {}, sourceKey = '') => {
  const source = normalizeToken(sourceKey || order.source || order.salesChannel);
  if (source === 'salao') {
    const waiterName = firstText(
      order.waiterName,
      order.additionalInfo?.salon?.waiterName,
      order.fullOrderData?.waiterName
    );
    const rawEntryChannel = firstText(
      order.entryChannel,
      order.additionalInfo?.salon?.entryChannel,
      order.fullOrderData?.entryChannel
    );
    const entryChannel = normalizeToken(rawEntryChannel);
    const isCustomerQr = entryChannel === 'tableqr'
      || (!rawEntryChannel && (
        Boolean(firstText(order.guestId, order.qrSubmissionId))
        || /^(qr|autoatendimentoqr)/.test(normalizeToken(waiterName))
      ));

    if (isCustomerQr) {
      return {
        actor: 'Cliente via QR Code',
        personLabel: 'Cliente identificado',
        personName: getCustomerName(order) || 'Não informado',
        kind: 'customer_qr',
      };
    }

    return {
      actor: 'Garçom',
      personLabel: 'Garçom responsável',
      personName: waiterName || 'Não informado',
      kind: 'waiter',
    };
  }

  if (source === 'balcao') {
    return {
      actor: 'Atendente do Balcão',
      personLabel: 'Atendente responsável',
      personName: firstText(order.attendantName) || 'Não informado',
      kind: 'counter',
    };
  }

  return null;
};
